import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const linkClass = (path: string) =>
    `whitespace-nowrap text-sm font-medium transition-colors duration-200 cursor-pointer ${
      location.pathname === path
        ? 'text-primary-500'
        : 'text-foreground-700 hover:text-primary-500'
    }`;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6 max-w-screen-2xl mx-auto">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-xl font-heading font-bold text-primary-500">
              韩漫大全
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={linkClass('/')}>首页</Link>
            <Link to="/category/all" className={linkClass('/category/all')}>分类</Link>
            <Link to="/about" className={linkClass('/about')}>关于我们</Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-700"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4 flex flex-col gap-3">
          <Link to="/" className={linkClass('/')}>首页</Link>
          <Link to="/category/all" className={linkClass('/category/all')}>分类</Link>
          <Link to="/about" className={linkClass('/about')}>关于我们</Link>
        </div>
      )}
    </nav>
  );
}